const firebaseConfig = {
    apiKey: "AIzaSyC6UvANBe5MS6xge4Ri0TyndrMnSSWxMXQ",
    authDomain: "creative-agency-5749b.firebaseapp.com",
    databaseURL: "https://creative-agency-5749b.firebaseio.com",
    projectId: "creative-agency-5749b",
    storageBucket: "creative-agency-5749b.appspot.com",
    messagingSenderId: "467183419385",
    appId: "1:467183419385:web:0ca84516b2154e06008728"
  };
  export default firebaseConfig;